import { Filesystem, Directory } from '@capacitor/filesystem'
import { FileOpener } from '@capacitor-community/file-opener'
import { PlatformService } from './index'

export const FileService = {
	async saveAndOpen(blob, filename) {
		if (!PlatformService.isNative()) {
			return this._webDownload(blob, filename)
		}

		const base64 = await this._blobToBase64(blob)

		// Use Cache directory to avoid permission issues on Android 11+
		const result = await Filesystem.writeFile({
			path: filename,
			data: base64,
			directory: Directory.Cache,
			recursive: true
		})

		await FileOpener.open({
			filePath: result.uri,
			contentType: blob.type
		})

		return result.uri
	},

	_webDownload(blob, filename) {
		const url = window.URL.createObjectURL(blob)
		const link = document.createElement('a')
		link.href = url
		link.download = filename
		link.click()
		setTimeout(() => window.URL.revokeObjectURL(url), 100)
		return url
	},

	_blobToBase64(blob) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader()
			reader.onloadend = () => resolve(reader.result.split(',')[1])
			reader.onerror = reject
			reader.readAsDataURL(blob)
		})
	}
}
